(function () {
  const FEE_VARIANT_ID = 45724448587949;
  const CUSTOM_FLAG_KEY = '_vgc_custom';

  let gateBusy = false;
  let refreshTimer = null;

  function hasUploadFromProperties(props) {
    if (!props) return false;
    for (const k in props) {
      const v = props[k];
      if (typeof v !== 'string') continue;
      if (v.indexOf('/uploads/') !== -1) return true;
      if (v.indexOf('uploadery.s3') !== -1) return true;
    }
    return false;
  }

  function isCustomFromProperties(props) {
    if (!props) return false;
    const v = props[CUSTOM_FLAG_KEY];
    if (v === true) return true;
    if (typeof v === 'string' && v.trim() !== '' && v !== '0' && v.toLowerCase() !== 'false') return true;
    return false;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart_fetch_failed');
    return await res.json();
  }

  async function setCartNote(note) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note })
    });
    if (!res.ok) throw new Error('note_update_failed');
  }

  async function addFee(qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: FEE_VARIANT_ID, quantity: qty }] })
    });
    if (!res.ok) throw new Error('fee_add_failed');
  }

  async function changeLineByKey(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (!res.ok) throw new Error('fee_change_failed');
  }

  async function syncFeeQty(cart, targetQty) {
    const feeLine = (cart.items || []).find(i => i.variant_id === FEE_VARIANT_ID);

    if (targetQty <= 0) {
      if (feeLine) await changeLineByKey(feeLine.key, 0);
      return;
    }

    if (!feeLine) {
      await addFee(targetQty);
      return;
    }

    if (feeLine.quantity !== targetQty) {
      await changeLineByKey(feeLine.key, targetQty);
    }
  }

  async function analyzeCart() {
    const cart = await getCart();

    let missing = 0;
    for (const item of (cart.items || [])) {
      const props = item.properties || {};
      if (!isCustomFromProperties(props)) continue;

      if (!hasUploadFromProperties(props)) {
        missing += (item.quantity || 1);
      }
    }

    const feeLine = (cart.items || []).find(i => i.variant_id === FEE_VARIANT_ID);
    const feeQty = feeLine ? feeLine.quantity : 0;

    return { cart, missing, feeQty };
  }

  function lockScroll(lock) {
    if (lock) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
    }
  }

  function showGateModal(missingCount, onCancel, onConfirm) {
    const overlay = document.createElement('div');
    overlay.id = 'vgc_gate_overlay';

    const modal = document.createElement('div');
    modal.id = 'vgc_gate_modal';

    modal.innerHTML = `
      <div class="vgc_gate_top">
        <div class="vgc_gate_title">Artwork needed before production</div>
        <p class="vgc_gate_sub">
          No design file detected for ${missingCount} item${missingCount === 1 ? '' : 's'}.
          Upload artwork, or continue and we will create it from your notes.
        </p>
        <div class="vgc_gate_badges">
          <span class="vgc_gate_badge">$25 setup fee each</span>
          <span class="vgc_gate_badge">${missingCount} missing</span>
        </div>
      </div>

      <div class="vgc_gate_body">
        <label class="vgc_gate_label" for="vgc_gate_note">Design notes (required)</label>
        <textarea id="vgc_gate_note" class="vgc_gate_note" placeholder="Exact text, colors, sizing, placement, and any reference details."></textarea>
        <div class="vgc_gate_help">
          Tip: If you choose upload instead, go back to the product page and upload using the Uploadery field.
        </div>
        <div id="vgc_gate_error" class="vgc_gate_error"></div>
      </div>

      <div class="vgc_gate_actions">
        <button type="button" id="vgc_gate_cancel" class="vgc_btn">I will upload a file instead</button>
        <button type="button" id="vgc_gate_confirm" class="vgc_btn vgc_btn_primary">Add setup fee and continue</button>
      </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    lockScroll(true);

    const err = modal.querySelector('#vgc_gate_error');
    const confirmBtn = modal.querySelector('#vgc_gate_confirm');

    function close() {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      lockScroll(false);
    }

    modal.querySelector('#vgc_gate_cancel').addEventListener('click', function () {
      close();
      onCancel();
    });

    modal.querySelector('#vgc_gate_confirm').addEventListener('click', async function () {
      const noteVal = (modal.querySelector('#vgc_gate_note').value || '').trim();

      if (!noteVal) {
        err.textContent = 'Design notes are required to continue without an upload.';
        err.style.display = 'block';
        return;
      }

      try {
        err.style.display = 'none';
        confirmBtn.disabled = true;
        await onConfirm(noteVal);
        close();
      } catch (e) {
        confirmBtn.disabled = false;
        err.textContent = 'Could not apply the setup fee. Try again.';
        err.style.display = 'block';
      }
    });

    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') {
        document.removeEventListener('keydown', esc);
        close();
        onCancel();
      }
    });
  }

  async function refreshGateState() {
    try {
      const { missing } = await analyzeCart();
      if (missing > 0) {
        document.documentElement.classList.add('vgc_gate_block');
      } else {
        document.documentElement.classList.remove('vgc_gate_block');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshGateState, 250);
  }

  async function gateAndCheckout() {
    if (gateBusy) return;
    gateBusy = true;

    try {
      const { cart, missing, feeQty } = await analyzeCart();

      if (missing > 0) {
        document.documentElement.classList.add('vgc_gate_block');

        const noteOk = (cart.note && String(cart.note).trim().length > 0);
        const feeOk = (feeQty === missing);

        if (!noteOk || !feeOk) {
          showGateModal(
            missing,
            function onCancel() {
              gateBusy = false;
              if (location.pathname !== '/cart') location.href = '/cart';
            },
            async function onConfirm(noteVal) {
              await setCartNote(noteVal);
              await syncFeeQty(await getCart(), missing);
              gateBusy = false;
              location.href = '/checkout';
            }
          );
          return;
        }

        gateBusy = false;
        location.href = '/checkout';
        return;
      }

      document.documentElement.classList.remove('vgc_gate_block');

      const feeLine = (cart.items || []).find(i => i.variant_id === FEE_VARIANT_ID);
      if (feeLine) await changeLineByKey(feeLine.key, 0);

      gateBusy = false;
      location.href = '/checkout';
    } catch (e) {
      gateBusy = false;
    }
  }

  function isCheckoutTrigger(el) {
    if (!el) return false;

    if (el.matches('button[name="checkout"], input[name="checkout"]')) return true;
    if (el.matches('a[href^="/checkout"], a[href*="/checkout"]')) return true;
    if (el.matches('[href="/checkout"], [data-checkout]')) return true;

    return false;
  }

  document.addEventListener('click', function (e) {
    const el = e.target && e.target.closest && e.target.closest('button, input, a');
    if (!isCheckoutTrigger(el)) return;

    e.preventDefault();
    e.stopPropagation();
    gateAndCheckout();
  }, true);

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !form.action) return;
    if (String(form.action).indexOf('/checkout') === -1) return;

    e.preventDefault();
    e.stopPropagation();
    gateAndCheckout();
  }, true);

  /* catch cart updates even when Dawn updates cart via fetch without page reload */
  (function wrapFetch() {
    if (!window.fetch) return;
    const orig = window.fetch;
    window.fetch = async function () {
      const res = await orig.apply(this, arguments);
      try {
        const url = arguments[0];
        if (typeof url === 'string' && url.indexOf('/cart/') !== -1) scheduleRefresh();
      } catch (e) {}
      return res;
    };
  })();

  /* init */
  document.addEventListener('DOMContentLoaded', function () {
    refreshGateState();
  });
})();
